import api from './index';

const basePath = '/api/v1/onboarding_steps';

export default {
  createOnboardingStepAnswer(onboardingStepId, body) {
    const data = { onboardingStepAnswer: body };
    const path = `${basePath}/${onboardingStepId}/onboarding_step_answers`;

    return api({
      method: 'post',
      data,
      url: path,
    });
  },
};
